var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-scanner"},[(!_vm.scanning)?_c('button',{on:{"click":_vm.startScanner}},[_vm._v(" Scannen ")]):_vm._e(),(_vm.scanning)?_c('button',{on:{"click":_vm.stopScanner}},[_vm._v(" Abbrechen ")]):_vm._e(),_c('video',{ref:"video",staticClass:"video"})])
}
var staticRenderFns = []

export { render, staticRenderFns }